import React from "react";
import './grid.css'

export function GridComponent({children, className}) {
    return (
        <div className={"grid" + " " + className}>
            {children}
        </div>
    )
}
